import React from "react";
import { Navigate } from "react-router-dom";

/** Legacy route — academic setup is split into list/detail pages under Academics. */
const AcademicSetupPage: React.FC = () => <Navigate to="../programs" replace />;

export default AcademicSetupPage;
